import { keyframes, styled } from 'styled-components';

const BUMP_SIZE = 48;
const BODY_WIDTH = BUMP_SIZE * 2;
const BODY_RADIUS = 8;
const PANEL_HEIGHT = 2;
const PANEL_EXPANDED_HEIGHT = BUMP_SIZE * 2;

const fadeIn = () => keyframes`
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(23px);
  }

  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
`;

const fadeOut = () => keyframes`
  from {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }

  to {
    opacity: 0;
    transform: translateX(-50%) translateY(23px);
  }
`;

export const ArrowPanel = styled.button`
  position: relative;
  width: ${BODY_WIDTH}px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border: none;
  cursor: pointer;
  touch-action: manipulation;
  user-select: none;
  max-height: 0;
  overflow: visible;
  background: ${({ theme }) => theme.colors.black_1};
  border-radius: ${BODY_RADIUS}px ${BODY_RADIUS}px 0 0;
  transition: max-height 0.25s ease;
  padding: 1px 0;
`;

export const ArrowBump = styled.div`
  width: ${BUMP_SIZE}px;
  height: ${BUMP_SIZE}px;
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.black_1};
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-shrink: 0;
  position: absolute;
  padding: 6px 0;
  margin: 0 auto;
  left: 0;
  right: 0;
  top: -${BUMP_SIZE / 3}px;
`;

export const ArrowLabel = styled.span`
  display: block;
  text-align: center;
  font-size: 10px;
  line-height: 14px;
  font-weight: 500;
  letter-spacing: 0.02em;
  color: ${({ theme }) => theme.colors.grey00_1};
  white-space: nowrap;
  padding-top: 2px;
  position: relative;
  z-index: 1;
  background: ${({ theme }) => theme.colors.black_1};
`;

export const ArrowTrack = styled.div<{ $visible: boolean }>`
  position: fixed;
  left: 50%;
  bottom: env(safe-area-inset-bottom, 0);
  z-index: 99;
  transform: translateX(-50%);
  transform-origin: 50% 100%;
  pointer-events: ${({ $visible }) => ($visible ? 'auto' : 'none')};
  animation: ${({ $visible }) => ($visible ? fadeIn : fadeOut)} 0.15s ease forwards;

  &:hover,
  &:focus-within {
    ${ArrowPanel} {
      max-height: ${PANEL_EXPANDED_HEIGHT}px;
    }
  }

  @media (hover: none) {
    &:active {
      ${ArrowPanel} {
        max-height: ${PANEL_HEIGHT}px;
      }
    }
  }
`;
